import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BookingPage from "../pages/booking/page";
import PaymentResultPage from "../pages/booking/PaymentResultPage";
import LoginPage from "../pages/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AppointmentsPage from "../pages/admin/appointments/page";
import ServicesPage from "../pages/admin/services/page";
import AvailabilityPage from "../pages/admin/availability/page";
import AccountingPage from "../pages/admin/accounting/page";
import CustomersPage from "../pages/admin/customers/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/reservar",
    element: <BookingPage />,
  },
  {
    path: "/reservar/resultado-pago",
    element: <PaymentResultPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/admin/dashboard",
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/citas",
    element: (
      <ProtectedRoute>
        <AppointmentsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/servicios",
    element: (
      <ProtectedRoute>
        <ServicesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/disponibilidad",
    element: (
      <ProtectedRoute>
        <AvailabilityPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/accounting",
    element: (
      <ProtectedRoute>
        <AccountingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/clientes",
    element: (
      <ProtectedRoute>
        <CustomersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
